import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Tooltip from '@mui/material/Tooltip'
import { makeStyles, useTheme } from '@mui/styles'

import SVGIcon from '../../svg-icon/svg-icon'

const allowedSizes = ['small', 'medium', 'large']
const iconSize = {
  small: '12px',
  medium: '15px',
  large: '15px',
}

const useStyles = makeStyles(theme => ({
  tooltip: {
    fontSize: 11,
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 'none',
    border: theme.border,
    borderRadius: '5px',
    background: theme.backgroundColor,
    '&:hover': {
      background: theme.backgroundColorLight,
      transition: 'all 0.2s ease-out',
    },
  },
  disabled: {
    cursor: 'default',
    background: theme.disabledColor,
    pointerEvents: 'none',
  },
  primary: {
    background: theme.colorPrimaryButtonBackground,
    '&:hover': {
      background: theme.colorPrimaryButtonBackgroundHover,
      transition: 'all 0.2s ease-out',
    },
  },
  small: {
    minHeight: '20px',
    maxHeight: '20px',
    minWidth: '20px',
    maxWidth: '20px',
  },
  medium: {
    minHeight: '32px',
    maxHeight: '32px',
    minWidth: '32px',
    maxWidth: '32px',
  },
  large: {
    minHeight: '45px',
    maxHeight: '45px',
    minWidth: '45px',
    maxWidth: '45px',
  },
}))

const SquareIconLink = (props) => {
  const classes = useStyles(props)
  const theme = useTheme()

  const {
    id,
    size = 'medium',
    icon,
    iconColor = theme.iconColorControlButton,
    onClick,
    customClass,
    disabled,
    tooltip = '',
    primary = false,
    href,
    target,
    dataQsId,
  } = props

  return (
    <Tooltip
      title={tooltip}
      classes={{
        tooltip: classes.tooltip,
      }}>
      <a
        id={id}
        data-qs-id={dataQsId}
        className={clsx(classes.button, classes[size], primary && !disabled && classes.primary, disabled && classes.disabled, customClass)}
        onClick={onClick}
        href={href}
        target={target}>
        <SVGIcon width={iconSize[size]} height={iconSize[size]} svg={icon} fill={iconColor} />
      </a>
    </Tooltip>
  )
}

SquareIconLink.propTypes = {
  icon: PropTypes.string.isRequired,
  href: PropTypes.string,
  target: PropTypes.string,
  size: PropTypes.oneOf(allowedSizes),
  customClass: PropTypes.string,
  tooltip: PropTypes.string,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  dataQsId: PropTypes.string.isRequired,
}

export default SquareIconLink
